// src/components/customers/tabs/tabs-Balance.jsx
import React, { useState } from "react";
import { useCustomerBalanceQuery, useAddCustomerBalanceMutation } from "@queries/customers";
import { useOrdersQuery } from "@queries/order";
import { useQueryClient } from "@tanstack/react-query";

export default function BalanceTab({ customer }) {
  const id = customer?.customer_id || customer?.id;
  const { data, isLoading, isError } = useCustomerBalanceQuery(id);
  const { data: ordersData, isLoading: isOrdersLoading } = useOrdersQuery({ customerId: id }, 1, 1000);
  const addBalance = useAddCustomerBalanceMutation();
  const queryClient = useQueryClient();

  const [orderId, setOrderId] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");

  const transactions = data?.data || [];
  const orders = ordersData?.data || [];

  const handleAddTransaction = async () => {
    if (!description.trim() || !amount.trim()) return;

    try {
      await addBalance.mutateAsync({
        id,
        payload: {
          order_id: orderId || null,
          description,
          amount: parseFloat(amount)
        }
      });
      setOrderId("");
      setDescription("");
      setAmount("");
      queryClient.invalidateQueries({ queryKey: ["customers", "balance", id] });
    } catch (err) {
      console.error("Failed to add transaction", err);
      alert("Failed to add transaction");
    }
  };

  if (isLoading) return <div className="oc-empty">Loading balance...</div>;
  if (isError) return <div className="oc-empty" style={{ color: "red" }}>Error loading balance</div>;

  return (
    <div>
      <div className="oc-card" style={{ marginBottom: 20 }}>
        <div className="oc-header">
          <h2>Transactions</h2>
        </div>
        <div className="oc-table-wrap">
          <table className="oc-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Washy account name</th>
                <th>Edited by</th>
                <th>washy account number</th>
                <th>Order Id</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Description</th>
                <th>balance</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length === 0 ? (
                <tr>
                  <td colSpan={9} style={{ textAlign: "center", padding: 24 }}>
                    No results!
                  </td>
                </tr>
              ) : (
                transactions.map((t, i) => (
                  <tr key={t.id || i}>
                    <td>{t.date_added}</td>
                    <td>{t.account_name}</td>
                    <td>{t.edited_by}</td>
                    <td>{t.account_number}</td>
                    <td>
                      {t.order_id ? (
                        <a href={`/orders/${t.order_id}`} target="_blank" rel="noreferrer">
                          {t.order_id}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{t.debit != null && t.debit !== "" ? Number(t.debit).toFixed(2) : ""}</td>
                    <td>{t.credit != null && t.credit !== "" ? Number(t.credit).toFixed(2) : ""}</td>
                    <td>{t.description}</td>
                    <td>{t.balance != null && t.balance !== "" ? Number(t.balance).toFixed(2) : ""}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="oc-card">
        <div className="oc-header">
          <h2>Add Transaction</h2>
        </div>
        <div className="oc-grid 3cols">
          <div className="oc-field">
            <label className="lbl">Order</label>
            <select
              className="oc-input"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              disabled={isOrdersLoading}
            >
              <option value="">No Order</option>
              {orders.map((o) => (
                <option key={o.order_id} value={o.order_id}>
                  {o.order_id} - {o.date_added} - {o.type || o.order_type || "N/A"} - {Number.isFinite(o.order_total) ? `${Number(o.order_total).toFixed(2)} JOD` : (o.total ? `${Number(o.total).toFixed(2)} JOD` : "N/A")}
                </option>
              ))}
            </select>
          </div>
          <div className="oc-field">
            <label className="lbl">Description</label>
            <input
              type="text"
              className="oc-input"
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="oc-field">
            <label className="lbl">Amount</label>
            <input
              type="number"
              step="0.01"
              className="oc-input"
              placeholder="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
        </div>
        <div style={{ textAlign: "right", marginTop: 12 }}>
          <button
            className="oc-btn"
            onClick={handleAddTransaction}
            disabled={addBalance.isLoading || !description.trim() || !amount.trim()}
          >
            <i className="fa fa-plus" style={{ marginRight: 6 }} />
            Add Transaction
          </button>
        </div>
      </div>
    </div>
  );
}

